export default "__VITE_ASSET__BT9n0lPh__"